var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{staticClass:"text-primary cursor-pointer",attrs:{"size":"21","icon":_vm.currentSkinFromMap.icon},on:{"click":_vm.nextSkin}})}
var staticRenderFns = []

export { render, staticRenderFns }